import React from 'react';

const shimmer = {
  background: 'linear-gradient(90deg, var(--slate) 25%, var(--slate-2) 50%, var(--slate) 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.5s infinite',
};

// Inject shimmer keyframe once
if (typeof document !== 'undefined' && !document.getElementById('shimmer-style')) {
  const s = document.createElement('style');
  s.id = 'shimmer-style';
  s.textContent = '@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }';
  document.head.appendChild(s);
}

export function SkeletonLine({ width = '100%', height = 14, style = {} }) {
  return <div style={{ width, height, borderRadius: 6, ...shimmer, ...style }} />;
}

export function SkeletonCard() {
  return (
    <div style={{
      background: 'var(--slate)', border: '1px solid var(--border)',
      borderRadius: 12, padding: 16, display: 'flex', flexDirection: 'column', gap: 10,
    }}>
      <SkeletonLine width="60%" height={16} />
      <SkeletonLine width="40%" height={12} />
      <SkeletonLine width="100%" height={10} />
    </div>
  );
}

export function SkeletonDetail() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', paddingTop: 56 }}>
      <div style={{ background: 'var(--slate)', padding: '32px 24px', borderBottom: '1px solid var(--border)' }}>
        <SkeletonLine width="50%" height={28} style={{ marginBottom: 12 }} />
        <SkeletonLine width="70%" height={14} style={{ marginBottom: 16 }} />
        <SkeletonLine width={100} height={28} style={{ borderRadius: 20 }} />
      </div>
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '24px 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 20 }}>
          {[1,2,3,4].map(i => <SkeletonCard key={i} />)}
        </div>
        <SkeletonCard />
      </div>
    </div>
  );
}
